import VText from '../../v-text/component-lib.esm.js';
import IconButton from '../../icon-button/component-lib.esm.js';
import { computed } from 'vue';
import CloseIcon from '../../../icons/component-lib.esm5.js';
import Card from '../../card/component-lib.esm2.js';
import { useTheme } from '../../../compositions/component-lib.esm7.js';
import { getTextColor } from '../../../styles/theme/component-lib.esm3.js';

//
var script = {
  name: 'NotificationCard',
  components: {
    Card,
    VText,
    IconButton,
    CloseIcon
  },
  props: {
    ...Card.props,
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    dismissable: {
      type: Boolean,
      default: true
    },
    dismissProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const theme = useTheme();
    const cardPropsToBind = computed(() => {
      // eslint-disable-next-line no-unused-vars
      const {
        title,
        text,
        dismissable,
        dismissProps,
        ...rest
      } = props;
      return rest;
    });
    const textColor = computed(() => {
      return getTextColor(props.color, theme);
    });
    const styles = computed(() => {
      return {
        '--c-text-color': textColor.value
      };
    });
    return {
      cardPropsToBind,
      styles,
      textColor
    };
  }
};
export { script as default };